import React, { ChangeEvent } from "react";
import { Updater } from "use-immer";

import { IgSwitch } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { IExperienceDashboardFilters } from "../../store/types/dashboardFilters";

interface DiscountFilterProps {
  isAllDiscounts: number | null;
  setDialogFilters: Updater<IExperienceDashboardFilters>;
}

export const DiscountFilter = ({
  setDialogFilters,
  isAllDiscounts,
}: DiscountFilterProps) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setDialogFilters((draft) => {
      draft.discountIncludeType = event.target.checked ? 2 : 1;
      return draft;
    });
  };
  return (
    <Grid item>
      <IgSwitch
        checked={!!(isAllDiscounts && isAllDiscounts !== 1)}
        onChange={handleChange}
        inputProps={{ "aria-label": "controlled" }}
      />
    </Grid>
  );
};
